import * as WebBrowser from 'expo-web-browser';

const openExternalUrl = async (url: string): Promise<void> => {
  await WebBrowser.openBrowserAsync(url);
};

export { openExternalUrl };
